// extracted by mini-css-extract-plugin
export default {"pagination":"fVGuw","previous":"su1rB"};